namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;

	export class ScoreAnimationView extends ViewBase
	{
		private _message : PIXI.Text;

		constructor(score:number, private _animationCompleteCallBack:()=>void)
		{
			super("ScoreAnimationView");

			this._message = new PIXI.Text("+"+score.toLocaleString(),
			{
				fontFamily: 'WellWait',
				fontSize: 60,
				fill: ['#ffffff', '#FFDEAD'],//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 3,
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 2,
				padding:20
			});
			this._message.x = -this._message.width;//110;
			this._message.y = 0;//-this._message.height*0.5;

			this.childByName("ScoreAnimation").childArmature.getSlot("piastres").display.addChild(this._message);

			this.playChildAnimation("ScoreAnimation","animtion0",()=>{
				this.stopChildAnimation("ScoreAnimation", "animtion0");
				this._animationCompleteCallBack();
			});
		}

		public destroy()
		{
			this._animationCompleteCallBack = null;

			this.childByName("ScoreAnimation").childArmature.getSlot("piastres").display.removeChild(this._message);
			this._message.destroy();

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/Board/ScoreAnimationView.ts